import nucleusToString from './nucleusToString';
export function getSpectraByNucleus(nucleus, data) {
    return data.filter((spectrum) => nucleusToString(spectrum.info.nucleus) === nucleus);
}
